import "./GarageDoorRepairSydney.module.css";
import Header from "@/reusable_sections/Header";
import RepairHero from "./sections/RepairHero";
import RepairIntro from "./sections/RepairIntro";
import CommonIssues from "./sections/CommonIssues";
import RepairProcess from "./sections/RepairProcess";
import WhyChooseRepair from "./sections/WhyChooseRepair";
import PricingTransparency from "./sections/PricingTransparency";
import RelatedServices from "./sections/RelatedServices";
import RepairFaq from "./sections/RepairFaq";
import RepairFinalCta from "./sections/RepairFinalCta";
import ServiceAreas from "./sections/ServiceAreas";
import Sitefooter from "./sections/Sitefooter";
export default function GarageDoorRepairSydneyPage() {
  return <div>
      <Header />
      <RepairHero />
      <RepairIntro />
      <CommonIssues />
      <RepairProcess />
      <WhyChooseRepair />
      <PricingTransparency />
      <RelatedServices />
      <RepairFaq />
      <RepairFinalCta />
      <ServiceAreas />
      <Sitefooter />
    </div>;
}